/*
  Ürün sayfası: beden seçimi → fiyat/görsel (sayfa yenilenmeden), lightbox,
  mobil nokta göstergesi, yapışkan çubuk + beden paneli, "Arşivden" önerileri.
  Sepete ekleme Dawn'ın product-form.js'i ile (<product-form>). Vanilla JS.
*/

const ALV_DESKTOP_MQ = window.matchMedia('(min-width: 900px)');
const ALV_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!customElements.get('alv-product')) {
  class AlvProduct extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.url = this.dataset.url;
      this.sizeIndex = Number(this.dataset.sizeIndex || 0);
      this.variants = JSON.parse(this.querySelector('[data-alv-variants]').textContent);
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-alv-variant-input]');
      this.sizeInputs = Array.from(this.querySelectorAll('[data-alv-size]'));
      this.submit = this.querySelector('[data-alv-submit]');
      this.priceBox = this.querySelector('[data-alv-price]');
      this.errorBox = this.querySelector('.product-form__error-message-wrapper');
      this.sticky = this.querySelector('[data-alv-sticky]');
      this.stickyBar = this.querySelector('.alv-sticky');
      this.panel = this.querySelector('[data-alv-size-panel]');
      this.media = Array.from(this.querySelectorAll('[data-alv-media]'));
      this.dots = Array.from(this.querySelectorAll('[data-alv-dots] .alv-product__dot'));

      this.sizeInputs.forEach((input) => input.addEventListener('change', () => this.onSizeChange(input.value)));
      this.form.addEventListener('submit', (e) => this.guardSubmit(e), true);

      if (this.sticky) {
        this.sticky.addEventListener('click', () => this.onStickyClick());
        document.body.classList.add('alv-has-sticky');
      }
      if (this.panel) this.setupPanel();
      this.setupDots();
      this.setupLightbox();
      this.syncButtons();
    }

    /* ---- varyant ---- */

    get selectedVariant() {
      const id = this.variantInput.value;
      return this.variants.find((v) => String(v.id) === String(id)) || null;
    }

    get productSoldOut() {
      return !this.variants.some((v) => v.available);
    }

    variantForSize(value) {
      return this.variants.find((v) => v.options[this.sizeIndex] === value) || null;
    }

    onSizeChange(value) {
      const variant = this.variantForSize(value);
      if (!variant) return;
      this.variantInput.value = variant.id;
      this.hideError();
      this.syncButtons();
      this.syncPanelSelection(value);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      this.refreshPrice(variant.id);
      if (variant.featured_media && variant.featured_media.id) this.showMedia(variant.featured_media.id);
    }

    refreshPrice(variantId) {
      // Fiyat tek snippet'ten (alv-price) gelir: bölümü sunucudan çekip yalnızca fiyat kutusunu değiştir
      const token = (this.priceToken = Symbol('price'));
      fetch(`${this.url}?variant=${variantId}&section_id=${this.sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          if (this.priceToken !== token) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-alv-price]');
          if (fresh) this.priceBox.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    }

    showMedia(mediaId) {
      const target = this.media.find((m) => m.dataset.mediaId === String(mediaId));
      if (!target) return;
      target.scrollIntoView({ block: 'center', behavior: ALV_REDUCED.matches ? 'auto' : 'smooth' });
    }

    syncButtons() {
      const selected = this.selectedVariant;
      const soldOut = this.productSoldOut || (selected && !selected.available);
      const addLabel = this.submit.querySelector('span');
      const soldLabel = this.submit.querySelector('.sold-out-message');

      this.submit.disabled = !!soldOut;
      if (addLabel && soldLabel) {
        addLabel.classList.toggle('hidden', !!soldOut);
        soldLabel.classList.toggle('hidden', !soldOut);
      }

      if (this.sticky) {
        const d = this.sticky.dataset;
        if (soldOut) {
          this.sticky.textContent = d.labelSold;
          this.sticky.disabled = true;
          this.stickyBar.classList.add('alv-sticky--sold-out');
        } else {
          this.sticky.disabled = false;
          this.stickyBar.classList.remove('alv-sticky--sold-out');
          this.sticky.textContent = selected ? d.labelAdd : d.labelChoose;
        }
      }
    }

    guardSubmit(e) {
      if (this.selectedVariant) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.showError(this.sticky ? this.sticky.dataset.labelChoose : '');
      const first = this.sizeInputs.find((i) => !i.disabled);
      if (first) first.focus();
    }

    showError(text) {
      if (!this.errorBox) return;
      this.errorBox.querySelector('.product-form__error-message').textContent = text;
      this.errorBox.hidden = false;
    }

    hideError() {
      if (this.errorBox) this.errorBox.hidden = true;
    }

    /* ---- mobil yapışkan çubuk + beden paneli ---- */

    onStickyClick() {
      if (this.selectedVariant) {
        this.form.requestSubmit();
      } else {
        this.openPanel();
      }
    }

    setupPanel() {
      this.panel.querySelectorAll('[data-alv-panel-close]').forEach((el) => el.addEventListener('click', () => this.closePanel()));
      this.panel.querySelectorAll('[data-alv-panel-size]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const value = btn.dataset.alvPanelSize;
          const input = this.sizeInputs.find((i) => i.value === value && !i.disabled);
          if (!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.closePanel();
        })
      );
      this.panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closePanel();
      });
    }

    syncPanelSelection(value) {
      if (!this.panel) return;
      this.panel.querySelectorAll('[data-alv-panel-size]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.alvPanelSize === value)));
    }

    openPanel() {
      clearTimeout(this.panelTimer);
      this.panel.hidden = false;
      void this.panel.offsetWidth;
      this.panel.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      const first = this.panel.querySelector('[data-alv-panel-size]:not([disabled])') || this.panel.querySelector('.alv-size-panel__close');
      trapFocus(this.panel, first);
    }

    closePanel() {
      if (!this.panel.hasAttribute('open')) return;
      this.panel.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.sticky);
      this.panelTimer = setTimeout(() => {
        if (!this.panel.hasAttribute('open')) this.panel.hidden = true;
      }, 280);
    }

    /* ---- mobil nokta göstergesi ---- */

    setupDots() {
      if (this.dots.length < 2 || !('IntersectionObserver' in window)) return;
      const dots = this.querySelector('[data-alv-dots]');
      const visible = new Set();
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = Number(entry.target.dataset.index);
            if (entry.isIntersecting) {
              visible.add(index);
              this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
            } else {
              visible.delete(index);
            }
          });
          // Galeri ekrandan çıkınca (bilgi bloğu, footer) gösterge de çekilir
          dots.classList.toggle('is-hidden', visible.size === 0);
        },
        { threshold: 0.5 }
      );
      this.media.forEach((m) => io.observe(m));
    }

    /* ---- lightbox ---- */

    setupLightbox() {
      this.lb = this.querySelector('[data-alv-lightbox]');
      if (!this.lb || this.media.length === 0) return;
      this.lbImg = this.lb.querySelector('[data-alv-lb-img]');
      this.lbStage = this.lb.querySelector('[data-alv-lb-stage]');
      this.lbCounter = this.lb.querySelector('[data-alv-lb-counter]');
      this.lbIndex = 0;
      this.zoomed = false;

      this.media.forEach((btn) => btn.addEventListener('click', () => this.openLightbox(Number(btn.dataset.index))));
      this.lb.querySelector('[data-alv-lb-close]').addEventListener('click', () => this.closeLightbox());
      this.lb.querySelector('[data-alv-lb-prev]').addEventListener('click', () => this.stepLightbox(-1));
      this.lb.querySelector('[data-alv-lb-next]').addEventListener('click', () => this.stepLightbox(1));
      this.lb.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeLightbox();
        else if (e.key === 'ArrowLeft') this.stepLightbox(-1);
        else if (e.key === 'ArrowRight') this.stepLightbox(1);
      });

      // Görsele tıklama: 2× yakınlaştır / geri al; yakınken sürükleyerek kaydır
      this.lbImg.addEventListener('click', (e) => {
        if (this.dragMoved) {
          this.dragMoved = false;
          return;
        }
        this.zoomed ? this.resetZoom() : this.zoomAt(e);
      });
      this.lbImg.addEventListener('pointerdown', (e) => this.dragStart(e));
      this.lbImg.addEventListener('pointermove', (e) => this.dragMove(e));
      this.lbImg.addEventListener('pointerup', (e) => this.dragEnd(e));
      this.lbImg.addEventListener('pointercancel', (e) => this.dragEnd(e));
    }

    openLightbox(index) {
      clearTimeout(this.lbTimer);
      this.lbOpener = document.activeElement;
      this.lb.hidden = false;
      void this.lb.offsetWidth;
      this.lb.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      this.goLightbox(index);
      trapFocus(this.lb, this.lb.querySelector('[data-alv-lb-close]'));
    }

    closeLightbox() {
      if (!this.lb.hasAttribute('open')) return;
      this.resetZoom();
      this.lb.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.lbOpener || this.media[this.lbIndex]);
      this.lbTimer = setTimeout(() => {
        if (!this.lb.hasAttribute('open')) this.lb.hidden = true;
      }, 220);
    }

    stepLightbox(delta) {
      if (this.zoomed) return;
      this.goLightbox((this.lbIndex + delta + this.media.length) % this.media.length);
    }

    goLightbox(index) {
      this.lbIndex = index;
      this.resetZoom();
      this.lbImg.style.opacity = '0';
      const src = this.media[index].dataset.full;
      const alt = this.media[index].querySelector('img')?.alt || '';
      const img = new Image();
      img.onload = () => {
        this.lbImg.src = src;
        this.lbImg.alt = alt;
        this.lbImg.style.opacity = '1';
      };
      img.src = src;
      if (this.lbCounter) this.lbCounter.textContent = `${index + 1} / ${this.media.length}`;
    }

    zoomAt(e) {
      const rect = this.lbImg.getBoundingClientRect();
      const ox = ((e.clientX - rect.left) / rect.width) * 100;
      const oy = ((e.clientY - rect.top) / rect.height) * 100;
      this.zoomed = true;
      this.pan = { x: 0, y: 0 };
      this.lbImg.style.transformOrigin = `${ox}% ${oy}%`;
      this.lbImg.style.transform = 'scale(2)';
      this.lb.classList.add('alv-lightbox--zoomed');
    }

    resetZoom() {
      this.zoomed = false;
      this.pan = { x: 0, y: 0 };
      this.lbImg.style.transform = '';
      this.lbImg.style.transformOrigin = '';
      this.lb.classList.remove('alv-lightbox--zoomed', 'alv-lightbox--dragging');
    }

    dragStart(e) {
      if (!this.zoomed) return;
      this.dragging = true;
      this.dragMoved = false;
      this.dragFrom = { x: e.clientX - this.pan.x, y: e.clientY - this.pan.y };
      this.lbImg.setPointerCapture(e.pointerId);
      this.lb.classList.add('alv-lightbox--dragging');
    }

    dragMove(e) {
      if (!this.dragging) return;
      this.pan = { x: e.clientX - this.dragFrom.x, y: e.clientY - this.dragFrom.y };
      if (Math.abs(this.pan.x) > 3 || Math.abs(this.pan.y) > 3) this.dragMoved = true;
      this.lbImg.style.transform = `translate(${this.pan.x}px, ${this.pan.y}px) scale(2)`;
    }

    dragEnd(e) {
      if (!this.dragging) return;
      this.dragging = false;
      this.lb.classList.remove('alv-lightbox--dragging');
      try {
        this.lbImg.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }
  }

  customElements.define('alv-product', AlvProduct);
}

if (!customElements.get('alv-related')) {
  class AlvRelated extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.querySelector('.alv-related__inner')) return;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.alv-related__inner');
          if (inner) this.appendChild(inner);
        })
        .catch(() => {});
    }
  }

  customElements.define('alv-related', AlvRelated);
}
